<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>

          <div class="row">
            <!-- faName -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.nameFa"
                [control]="form?.get('nameFa')"
                [label]="fields + 'nameFa' | translate"
              >
              </form-field>
            </div>
            <!-- enName -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <form-field
                [(value)]="model.nameEn"
                [control]="form?.get('nameEn')"
                [label]="fields + 'nameEn' | translate"
                [classList]="'smsText dir-ltr'"
              >
              </form-field>
            </div>

            <!-- fieldType -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                class="tw-w-full"
                enumName="CustomFieldTypes"
                [label]="fields + 'CustomFieldTypes'"
                [control]="form?.get('FieldTypes')"
                [(value)]="model.fieldType"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
